var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course__review"},[_c('h3',{domProps:{"textContent":_vm._s(_vm.$t('rating'))}},[_vm._v("Valoración")]),_c('course-review-rating',{attrs:{"item":_vm.item}}),_c('course-review-comments',{attrs:{"item":_vm.item}}),_c('course-review-form',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }